import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useDevelopmentEffect } from "../../hooks/_internal/useDevelopmentEffect.js";
import { IconOpenIn } from "../../icons/IconOpenIn.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import Link_module from "./Link.module.js";
const Link = /*#__PURE__*/ forwardRef(({ as, external, className, theme, children, testId, ...props }, ref)=>{
    const As = as ?? 'a';
    useDevelopmentEffect(()=>{
        if (as && 'Link' !== as.displayName) {
            const asComponent = as;
            console.error("[Link] The `as` property should only be used with React Router links. It looks like the component that you passed does not match the criteria:", asComponent.displayName ?? asComponent.name ?? asComponent);
        }
    }, [
        as
    ]);
    return /*#__PURE__*/ jsxs(As, {
        className: combineClasses(Link_module.link, className),
        target: external ? '_blank' : void 0,
        rel: external ? 'noopener' : void 0,
        "data-theme": theme,
        "data-testid": testId,
        ...props,
        ref: ref,
        children: [
            children,
            external && /*#__PURE__*/ jsx(IconOpenIn, {})
        ]
    });
});
Link.displayName = 'Link';
export { Link };
